import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
export const RecoverMeetingCaptureApiSchema = {
    params: z.object({
        entityId: CornSchema,
        startTime: z.string().datetime(),
    }),
    response: z.object({
        message: z.string(),
        details: z.unknown(),
    }),
};
export const RecoverMeetingCaptureRequestSchema = RecoverMeetingCaptureApiSchema.params;
export const RecoverMeetingCaptureResponseSchema = RecoverMeetingCaptureApiSchema.response;
